// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3Lv_a","ButtonThin":"Button_ButtonThin__2fIzy","ButtonThinSmall":"Button_ButtonThinSmall__cAul3","ButtonSmall":"Button_ButtonSmall__AADCS"};